module.exports = __webpack_public_path__ + "img/xbox.a18ab3cc.png";